import { Controller } from 'stimulus'

export class MatchHeightController extends Controller {
  static targets = ['item']

  itemTargets: HTMLElement[]

  private _subscriptiosn: VoidFunction[] = []

  connect() {
    this.refresh()
  }

  refresh() {
    this._setHeight('')

    const mql = window.matchMedia('(max-width: 767px)')

    if (mql.matches) {
      return
    }

    const max = this.itemTargets.reduce(
      (max, item) => Math.max(max, item.clientHeight),
      0
    )

    // set same height
    this._setHeight(`${max}px`)
  }

  private _setHeight(height: string): void {
    this.itemTargets.forEach((item) => (item.style.height = height))
  }
}
